// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"ca5e0c55","453":"9463dc49","551":"0261efa3","745":"01188b30"}[chunkId] + ".chunk.js";
};